import axios from "axios"
import * as React from 'react';
import { useEffect, useState } from "react"
import { FaList, FaSpinner } from "react-icons/fa"
import { useSelector } from "react-redux"
import { toast } from "react-toastify"
import { BACKEND } from "../config/configEnvs"
import TareaAdministracion from "../components/tareas/TareaAdministracion";

const Tareas = () => {

  const user = useSelector((state) => state.auth.user)

  const [tasksLoading, setTasksLoading] = useState(false)

  const [adminTasks, setAdminTasks] = useState([]) // Tareas de administración

  const getAdminTasks = async () => { // Obtener tareas
    try {
      setTasksLoading(true)
      const response = await axios.get(`${BACKEND}/api/tareasAdministracion?where[worker][equals]=${user.id}&limit=0`)
      setAdminTasks(response.data.docs)
    } catch (error) {
      console.log(error)
      toast.error("Error al obtener las tareas de administración")
    } finally {
      setTasksLoading(false)
    }
  }

  // Funciones de arranque de componente o cambio de estados

  useEffect(() => { //Cuando se carga el componente se traen todas las marcas en las que el usuario está involucrado (proceso del servidor) y el número global de tareas
    getAdminTasks()
  }, [])

  const formatDate = (dateString) => { // Formateo de fecha
    const date = new Date(dateString);
    if (isNaN(date)) return "Fecha inválida";
  
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
  
    return `${day}/${month} ${hours}:${minutes}`
  };

  // Modificación de tareas de administración

  const handleAdminTaskStatusChange = async (taskId, newStatus) => {
    try {
      const dataToSend = {
        status: newStatus,
        ...(newStatus === "Finalizado" && { deliverDate: new Date().toISOString() }) // Condicional para enviar deliverDate
      };
  
      const response = await axios.put(`${BACKEND}/api/tareasAdministracion/${taskId}`, dataToSend);
  
      if (response.status === 200) {
        // Actualiza el estado local de la tarea
        const updatedTasks = adminTasks.map((task) => 
          task.id === taskId ? { ...task, status: newStatus } : task
        );
        setAdminTasks(updatedTasks);
      }
  
    } catch (error) {
      console.log(error);
      toast.error("Error actualizando el estado de la tarea: " + error);
    }
  };

  const handleUpdateWorkerNotesAdminTask = (taskId, workerNotes) => {
    const updatedTasks = adminTasks.map((task) => 
      task.id === taskId ? { ...task, workerNotes: workerNotes } : task
    );
    setAdminTasks(updatedTasks);
  }

  const pendingTasks = adminTasks.filter((task) => task.status === "Por comenzar");

  const inProcessTasks = adminTasks.filter((task) => task.status === "En proceso");

  const finishedTasks = adminTasks.filter((task) => task.status === "Finalizado");

  return (
    <div className="flex flex-col h-screen">

      {/* Header */}
      <div className="flex flex-row p-6 w-full bg-gray-100 mb-0 justify-between items-center">
        {/* Sección de la lista de tareas */}
        <div className="flex items-center gap-4">
          <FaList className="text-zinc-700 text-2xl" />
          <h2 className="text-2xl font-bold text-zinc-700 hover:cursor-pointer hover:text-orange-500 transition-all duration-200">
            Tareas
          </h2>
        </div>
      </div>
  
      {/* Body */}
      <div className="flex flex-grow w-full min-h-0">

          {tasksLoading ? (

            <div className="flex w-full h-full text-gray-700">
                <div className="flex w-full h-full text-xs gap-2 items-center justify-center">
                  <span>Cargando, por favor espera...</span>
                <FaSpinner className="animate-spin text-gray-500" />
              </div>
            </div>

          ) : (

            <div className="flex flex-grow flex-row gap-2 w-full text-xs p-2">
            
              {/* Tareas pendientes */}
              <div className="flex flex-grow w-1/3 flex-col border rounded-lg border-gray-400 p-1 gap-2">

                {/* Encabezado fijo */}
                <div className="flex items-center justify-between bg-yellow-100 text-yellow-700 p-2 border-gray-500 rounded-md shadow">
                  <span className="font-semibold">Tareas por comenzar</span>
                  <span className="font-bold">{pendingTasks.length}</span>
                </div>

                {/* Contenedor con scroll */}
              
                  {pendingTasks.length > 0 ? (
                    <div className="flex flex-col gap-2 overflow-y-auto border-t border-gray-200 pt-2 min-h-0">
                      {pendingTasks.map((task) => (
                        <TareaAdministracion
                          key={task.id}
                          register={task}
                          handleAdminTaskStatusChange={handleAdminTaskStatusChange}
                          formatDate={formatDate}
                          handleUpdateWorkerNotesAdminTask={handleUpdateWorkerNotesAdminTask}
                        />
                      ))}
                    </div>
                  ) : (
                    <div className="flex flex-grow w-full items-center justify-center px-8 text-center border rounded-sm shadow border-gray-300 text-xs text-gray-400">
                      No hay tareas por comenzar
                    </div>
                  )}
              </div>

              {/* Tareas en proceso */}
              <div className="flex flex-grow w-1/3 flex-col border rounded-lg border-gray-400 p-1 gap-2">

                {/* Encabezado fijo */}
                <div className="flex items-center justify-between bg-blue-100 text-blue-700 p-2 border-gray-500 rounded-md shadow">
                  <span className="font-semibold">Tareas en proceso</span>
                  <span className="font-bold">{inProcessTasks.length}</span>
                </div>

                {/* Contenedor con scroll */}
                {inProcessTasks.length > 0 ? (
                  <div className="flex flex-col gap-2 overflow-y-auto border-t border-gray-200 pt-2 min-h-0">
                    {inProcessTasks.map((task) => (
                      <TareaAdministracion
                        key={task.id}
                        register={task}
                        handleAdminTaskStatusChange={handleAdminTaskStatusChange}
                        formatDate={formatDate}
                        handleUpdateWorkerNotesAdminTask={handleUpdateWorkerNotesAdminTask}
                      />
                    ))}
                  </div>
                ) : (
                  <div className="flex flex-grow w-full items-center justify-center px-8 text-center border rounded-sm shadow border-gray-300 text-xs text-gray-400">
                    No hay tareas en proceso
                  </div>
                )}
              </div>
              
              {/* Tareas finalizadas */}
              <div className="flex flex-grow w-1/3 flex-col border rounded-lg border-gray-400 p-1 gap-2">

                {/* Encabezado fijo */}
                <div className="flex items-center justify-between bg-green-100 text-green-700 p-2 border-gray-500 rounded-md shadow">
                  <span className="font-semibold">Tareas finalizadas</span>
                  <span className="font-bold">{finishedTasks.length}</span>
                </div>

                {/* Contenedor con scroll */}
                {finishedTasks.length > 0 ? (
                  <div className="flex flex-col gap-2 overflow-y-auto border-t border-gray-200 pt-2 min-h-0">
                    {finishedTasks.map((task) => (
                      <TareaAdministracion
                        key={task.id}
                        register={task}
                        handleAdminTaskStatusChange={handleAdminTaskStatusChange}
                        formatDate={formatDate}
                        handleUpdateWorkerNotesAdminTask={handleUpdateWorkerNotesAdminTask}
                      />
                    ))}
                  </div>
                ) : (
                  <div className="flex flex-grow w-full items-center justify-center px-8 text-center border rounded-sm shadow border-gray-300 text-xs text-gray-400">
                    No hay tareas finalizadas
                  </div>
                )}
              </div>

            </div>
        
          )}
  
      </div>

    </div>
  );
  
}

export default Tareas